<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
    <section class="content">
        <ngx-spinner size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="false">
            <p style="color: white"> Loading... </p>
        </ngx-spinner>

        <div class="card  card-secondary">
            <div class="card-header">
                <div class="card-title">
                    <i class="fa fa-file-excel-o"></i> Download Excel
                </div>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" (click)="Loaddata();">
                        <i class="fas fa-sync"></i></button>
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                        <i class="fas fa-minus"></i></button>
                </div>
            </div>
            <div class="card-body">
                <div class="row justify-content-md-center">
                    <div class="col col-lg-3">
                        <mat-form-field class="example-full-width" style="text-align:center">
                            <input matInput [(ngModel)]="text_f" [ngModelOptions]="{standalone: true}"
                                placeholder="คำค้นหา" style="text-align:center">
                            <button *ngIf="text_f" matSuffix mat-icon-button aria-label="Clear" (click)="text_f=''">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row justify-content-md-center">
                    <div class="col col-lg-9">
                        <div class="card-body table-responsive p-2" style="height: 650px">
                            <table #tb_data class="table table-striped table-hover table-head-fixed">
                                <thead>
                                    <tr class="headText text-primary">
                                        <th style="text-align:center">ลำดับ</th>
                                        <th style="text-align:left">หัวข้อ</th>
                                        <th style="text-align:left">คำอธิบาย</th>
                                        <th style="text-align:center">. .</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of dataApi | filter:text_f; let i = index;">
                                        <td style="text-align:center">{{i+1}}</td>
                                        <td style="text-align:left">{{item.name}}</td>
                                        <td style="text-align:left">{{item.Description}}</td>
                                        <td style="text-align:center">
                                            <button class="btn btn-outline-success btn-sm" [disabled]="Load"
                                                (click)="Loaddata0(item);item.Loadding=true;">
                                                <i class="far fa-file-excel"></i> Download </button>
                                        </td>
                                        <td style="text-align:center">
                                            <mat-spinner *ngIf="item.Loadding"></mat-spinner>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</div>
<app-footer></app-footer>